var Model = require("../types/Model.js");
// eslint-disable-next-line node/no-missing-require
var ReactNative = require("react-native");
var AppState = ReactNative.AppState;
// eslint-disable-next-line node/no-missing-require
const AsyncStorage = require("@react-native-async-storage/async-storage").default;

var LOGOUT_TIMER = 5 * 60 * 1000; // Time of inactivity to time out
var INTERVAL_TIMER = 1 * 60 * 1000; // Every minute check if should timeout

module.exports = Model({
	name: "passwordtimeout",

	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	show_timeout: show_timeout,
	timer_reset: timer_reset,

	_timer: null,
	_processedLoad: false,
	_isSet: false,
	_wasTokenLogin: false,
	_handleAppStateChange: null,
	_isCalling: false,
	_offline: false,
	_last_time: 0,
	_isSetOrg: false,
	_changeListener: null,
});

function init() {
	this._timer = setInterval(this.show_timeout.bind(this), INTERVAL_TIMER);
	this._handleAppStateChange = handleAppStateChange.bind(this);
	this._changeListener = AppState.addEventListener("change", this._handleAppStateChange);

	this.push(false);

	AsyncStorage.getItem("passwordLogin").then(function(data){
		this._wasTokenLogin = data !== "true";
		AsyncStorage.removeItem("passwordLogin");
	}.bind(this)).catch(function(e){
		console.log("AsyncStorage error: ", e);
		AsyncStorage.removeItem("passwordLogin");
	});

}

function uninit() {
	clearInterval(this._timer);
	if(this._changeListener){
		this._changeListener.remove();
	}
}

function listeners() {
	return {
		"preferences:updated": handle_preferences_update,
		"calling:updated": handle_calling_update,
		"connectivity:offline": handle_offline,
		"connectivity:online": handle_online,
		"orgautologout:updated": handle_auto_logout
	};
}

function triggers() {
	return {
		"login": handle_login,
		"reset": timer_reset
	};
}

function handle_offline() {
	this._offline = true;
}

function handle_online() {
	this._offline = false;
}

function handle_preferences_update(data) {
	if(!data.type) return;
	this._isSet = data.autologout;

	if(this._processedLoad) return;

	this._processedLoad = true;
	if(this._isSet && this._wasTokenLogin)
		this.push(true);
}

function handle_calling_update(data){
	if(data.state !== "idle"){
		this._isCalling = true;
	}else{
		this._isCalling = false;
	}
	this.timer_reset();
}

function handleAppStateChange(appState){
	if(appState === "inactive" || appState === "background"){
		AsyncStorage.setItem("timestamp", currentTime().toString());
	}else{
		AsyncStorage.getItem("timestamp").then(function(timeString){
			AsyncStorage.removeItem("timestamp");
			var time = parseInt(timeString, 10);
			this._last_time = time;
			this.show_timeout();
		}.bind(this)).catch(function(e){
			console.log("AsyncStorage error: ", e);
			AsyncStorage.removeItem("timestamp");
		});
	}

	this.timer_reset();
}

function timer_reset(){
	this._last_time = Date.now();
}

function show_timeout(){
	if(!(this._isSet || this._isSetOrg) || this._isCalling)
		return;

	var hasTimedOut = (currentTime() - this._last_time) > LOGOUT_TIMER;

	if(!hasTimedOut) return;

	if(!this.data)
		this.push(true);
}

function handle_login(data) {
	var email = data.email;
	var password = data.password;

	this.emit("usermetrics:trigger:track", "enter password to login");
	this.api.auth.login(email, password)
		.then(handle_login_success.bind(this))
		.catch(handle_login_fail.bind(this));
}

function handle_login_success() {
	this.emit("usermetrics:trigger:track", "login successful");
	this.push(false);
	this.timer_reset();
}

function handle_login_fail(error) {
	this.emit("usermetrics:trigger:track", "login failed");
	var status = error.status;

	var status_map = {
		0: "login.loginerror1",
		401: "login.loginerror5",
	};

	var message = status_map[status] || "login.loginerror0";
	if (message) this.extend({
		message: message
	});

	// If the user is offline a 'toast' message saying that will overide any
	// other messages.
	if (this._offline) message = "disconnected.youarecurrentlyoffline";

	this.emit("toast:trigger:show", {
		content: message,
		style: "error"
	});
}

function currentTime(){
	if (!Date.now) {
		Date.now = function now() {
			return new Date().getTime();
		};
	}

	return Date.now();
}

function handle_auto_logout(data){
	this._isSetOrg = data;

	if(this._processedLoadOrg) return;

	this._processedLoadOrg = true;
	if(this._isSetOrg && this._wasTokenLogin)
		this.push(true);
}